import { render, staticRenderFns } from "./ImportSchoolContacts.vue?vue&type=template&id=7c9e11c9&"
import script from "./ImportSchoolContacts.vue?vue&type=script&lang=js&"
export * from "./ImportSchoolContacts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports